import React, { Component }  from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import parse from "html-react-parser";
import * as sanitizeHtml from "sanitize-html";

import {history} from '../../router';
import {FORMS_URL} from '../../router/urls';
import {Badge} from 'react-bootstrap';
import {Tooltip} from 'primereact/tooltip';
import {getProcessStatus} from '../../helpers';
import {AdminRequestDialog} from './Dialogs/AdminRequest';
import {notify} from './Utils';

import { onAdminRequest } from '../../actions';

const dialogs = {
  adminRequest: null,
}

class MasterTable extends Component {
  componentWillMount() {
    this.setState({
      dialogs: {...dialogs}
    })
  }

  onVisibleDialogs = (name, process_id) => () => {
    this.setState((prevState) => ({
      dialogs: {
        ...prevState.dialogs,
        [name]: true
      },
      process_id,
    }))
  }

  onHideAllDialogs = () => {
    this.setState({
      dialogs: {...dialogs}
    })
  }

  onHideDialogs = (name) => () => {
    this.setState((prevState) => ({
      dialogs: {
        ...prevState.dialogs,
        [name]: false
      }
    }))
  }

  onSubmitAdminRequest = (comment) => {
    const { process_id } = this.state
    const { onAdminRequest } = this.props

    onAdminRequest(comment, process_id, {
      success: () => {
        this.onHideAllDialogs()
        notify('Ваше сообщение отправлено')
      },
      error: this.errorHandlerAfterDialogs,
    })
  }

  errorHandlerAfterDialogs = (error, response) => {
    this.onHideAllDialogs()

    if (response) {
      const resp = JSON.parse(response)
      notify(resp?.message ?? 'Действие временно недоступно')
      return
    }
    notify('Действие временно недоступно',)
  }

  goForm = (opts) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    const {form_type, process_id} = opts;
    history.push(FORMS_URL({ form_type, process_id}));
  };

  openNavigator = (orn) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    window.open(`https://navigator.sk.ru/orn/${orn}`)
  }

  sendAdminMsg = (process_id) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    this.onVisibleDialogs('adminRequest', process_id)()
  }

  render() {
    const {
      tabInfo: {
        title,
        id,
        description
      },
      rows
    } = this.props

    return (
      <div className='reportbox-content'>
        <h4>{title}</h4>
        <p>{parse(sanitizeHtml(description))}</p>
        <div className='line' />
        <table className='table table-hover table-bordered'>
          <thead>
            <tr>
              <th>Рег.№</th>
              <th>Дата</th>
              <th>Заявитель</th>
              <th>Организация</th>
              <th>Менторы</th>
              <th>Общая информация</th>
              <th>Сообщение администратора</th>
              <th>Операции</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={12} style={{ textAlign: 'center' }}>Нет записей</td>
              </tr>
            ) : rows.map((row, idx) => {
              return (
                <tr className={`report-list-group request-${row.process_id}`} key={idx} onClick={this.goForm(row)}>
                  <td className='label-num-cell'>
                    {row.reg_number ?? '-'}
                  </td>
                  <td className='label-num-cell'>
                    {row.reg_date ? moment(row.reg_date).format('DD.MM.YYYY') : '-'}
                  </td>
                  <td className='label-num-cell'>
                    {`${row.ln} ${row.fn} ${row.phone}, ${row.email}`}
                  </td>
                  <td className='label-num-cell'>
                    {row.name}
                  </td>
                  <td className='label-num-cell mentors'>
                    {
                      row.mentors.map((item, i) => [
                        i > 0 && ", ",
                        <span style={{ display: 'inline' }}>{item}</span>
                      ])
                    }
                    {/* <Badge>{row.mentors.length}</Badge>
                    {
                      row.mentors.length ? <Tooltip
                        target={`.request-${row.process_id} .mentors`}
                        autoHide={false}
                        position='top'
                        className='mentor-tooltip'
                      >
                        {
                          row.mentors.map((item) => {
                            return <span>{item}</span>;
                          })
                        }
                      </Tooltip> : null
                    } */}
                  </td>
                  <td className='label-num-cell cell-link'>
                    <a href='/' onClick={this.openNavigator(row.orn)}>{`https://navigator.sk.ru/${row.orn}`}</a>
                  </td>
                  <td className='label-num-cell'>
                  {row.comment}
                  </td>
                  <td className='label-num-cell'>
                    {id === 1 && (<button className='btn btn-primary btn-xs' onClick={this.sendAdminMsg(row.process_id)}>Сообщение администратору</button>)}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <AdminRequestDialog
            visible={this.state.dialogs.adminRequest}
            onHide={this.onHideAllDialogs}
            onSubmit={this.onSubmitAdminRequest}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onAdminRequest: (comment, process_id, handlers) => dispatch(onAdminRequest(comment, process_id, handlers))
})

const mapStateToProps = state => ({
  flows: state.forms.flows,
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterTable);
